import { Property } from '../plugins/pattern-type.model';
import { PropertyType } from '../plugins/property-type.model';


export class ParameterHelper {

  public static readonly MIN_REQUIRED = 'minRequired';
  public static readonly MAX_ALLOWED = 'maxAllowed';

  // The secret annotation only forces use of a variable. Usage of a secret is not enforced!
  public static readonly SECRET = 'secret';

  // The secretPreserving annotation illustrates that secrets are supported and can be used without leaking the value.
  public static readonly SECRET_PRESERVING = 'secretPreserving';

  public static readonly SEPARATORS = 'separators';
  public static readonly SWITCHED_SEPARATORS = 'switchedSeparators';
  public static readonly SYNTAX = 'syntax';

  // The expected lower bound for the element’s value.
  public static readonly MIN = 'min';
  // The expected upper bound for the element’s value.
  public static readonly MAX = 'max';

  static getSpecificParameterValueNumber(parameterName: string, parameters: any, propertyType?: PropertyType): number {
    return ParameterHelper.getSpecificParameterValue(parameterName, parameters, propertyType);
  }

  static getSpecificParameterValueBoolean(parameterName: string, parameters: any, propertyType?: PropertyType): boolean {
    return ParameterHelper.getSpecificParameterValue(parameterName, parameters, propertyType);
  }

  static getSpecificParameterValue(parameterName: string, parameters: any, propertyType?: PropertyType): any {
    if (!parameters[parameterName] && !!propertyType) {
      const defaultParam = propertyType.parameters.find(param => param.parameterKey === parameterName);
      return !!defaultParam ? defaultParam.defaultValue : undefined;
    }
    return parameters[parameterName];
  }

  static isRequiredPropertyValueWithNoDefault(patterTypeProp: Property | undefined, propertyType: PropertyType | undefined, defaultValue: string | null): any {
        if (patterTypeProp && propertyType) {
            const minRequired =  ParameterHelper.getSpecificParameterValueNumber(ParameterHelper.MIN_REQUIRED, patterTypeProp.parameters, propertyType);
            return !defaultValue && minRequired > 0;
        }
        return false;
  }

  static isMultiAllowed(patternPropType: Property | undefined): boolean {
    const maxAllowed: unknown = patternPropType?.parameters?.[ParameterHelper.MAX_ALLOWED];
    if (typeof maxAllowed !== 'number') {
      return true;
    }
    return maxAllowed > 1;
  }
}
